import GetTimeStamp from "./queries/getTimeStamp";
import GetTimeDuration from "./queries/getTimeDuration";
import GetDistance from "./queries/getDistance";
import GetPosition from "./queries/getPosition";
import IsVRConnected from "./queries/isVRConnected";
import GetUserPosition from "./queries/getUserPosition";
import GetUserOrientation from "./queries/getUserOrientation";

class QueryFactory {
    constructor() {
        this.queries = [
            GetTimeStamp,
            GetTimeDuration,
            GetDistance,
            GetPosition,
            IsVRConnected,
            GetUserPosition,
            GetUserOrientation
        ];

        this.queries = this.queries.map(query => new query());
    }

    async executeQuery(queryName, params, options) {
        const query = this.queries.find(query => query.name === queryName);
        if (query) {
            return query.execute(params, options);
        } else {
            console.error("Query not found. Name: " + queryName);
        }
    }
}

export default new QueryFactory();
